import { Column, defaultColActionDef, defaultColDef, TABLE_ACTION } from '@qrios/frontend-library';
import { predefinedColumns } from '../../../../../common/table/columns';

const ACTIONS = [TABLE_ACTION.EDIT];
export const columns: Column[] = [
  {
    ...defaultColDef,
    field: 'id',
    headerName: 'User Id',
    flex: 1,
    hide: true
  },
  {
    ...defaultColDef,
    field: 'name',
    headerName: 'User name',
    flex: 1
  },
  {
    ...defaultColDef,
    field: 'role',
    headerName: 'User Role',
    flex: 1
  },
  {
    ...defaultColDef,
    field: 'emailAddress',
    headerName: 'Email Address',
    flex: 1
  },
  predefinedColumns.date({ field: 'creationDate', headerName: 'Creation Date' }),
  defaultColActionDef(ACTIONS)
];
